import React from "react";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS, COMPANY } from "../../mock";
import usePublicData from "../../hooks/usePublicData";
import useReveal from "../../hooks/useReveal";

export default function Testimonials() {
  const { data: reviews } = usePublicData("/reviews", TESTIMONIALS);
  useReveal([reviews]);
  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="container-x">
        <div className="text-center max-w-2xl mx-auto mb-14 reveal">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="h-px w-10 bg-[#2f9fe6]" />
            <span className="text-[#2f9fe6] tracking-[0.24em] text-xs font-semibold uppercase">Testimonials</span>
            <span className="h-px w-10 bg-[#2f9fe6]" />
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0f2740] leading-tight mb-4">
            Our clients say it best
          </h2>
          <p className="text-[#6b7683] text-lg">Real people with real experiences to help you feel confident in your choice of renovation experts.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {reviews.slice(0, 4).map((t, i) => (
            <div key={t.id || t.name} className={`reveal delay-${(i % 4) + 1} bg-[#f7f9fb] rounded-2xl p-7 border border-[#eef1f4] hover:shadow-xl hover:-translate-y-1 transition-all duration-300`}>
              <Quote className="w-9 h-9 text-[#2f9fe6]/30 mb-4" />
              <p className="text-[#4a5560] leading-relaxed mb-6 text-[15px]">“{t.text}”</p>
              <div className="flex mb-3">
                {[...Array(t.rating || 5)].map((_, j) => (
                  <Star key={j} className="w-4 h-4 fill-[#2f9fe6] text-[#2f9fe6]" />
                ))}
              </div>
              <div className="font-display font-semibold text-[#0f2740]">{t.name}</div>
              <div className="text-sm text-[#9aa4af]">{t.role}</div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center reveal">
          <a href={COMPANY.reviewsUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-[#2f9fe6] font-semibold hover:gap-3 transition-all">
            View more reviews on Google
          </a>
        </div>
      </div>
    </section>
  );
}
